/**
 * Which days should be marked when a teacher taps `day` on the hundreds chart.
 *
 * The chart behaves like a "count up to today" fill level rather than a grid of
 * independent toggles:
 *   - Tapping an UNMARKED day counts up to it — marks every day 1..day, filling
 *     in any days that were missed. So one tap catches the whole count up.
 *   - Tapping an already-COUNTED day steps back to the day before it — marks
 *     1..(day-1), un-counting that day and anything after it. So an over-count
 *     or a mis-tap is a single tap to fix (tapping day 1 clears everything).
 *
 * Returns the full set of day numbers to persist (always contiguous 1..N).
 */
export function fillThrough(day: number, isMarked: boolean): number[] {
  const through = isMarked ? day - 1 : day;
  const days: number[] = [];
  for (let n = 1; n <= through; n++) days.push(n);
  return days;
}
